// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "app.beewallet",
    name: "Bee Wallet",
    homepage: "https://www.beewallet.app",
    image_id: "f90bc33f-f085-40cf-7538-fae5ae84f900",
    app: {
        browser: null,
        ios: "https://apps.apple.com/lt/app/bee-for-uniswap-pancakeswap/id1617257467",
        android: null,
        mac: null,
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "beewallet.app://",
        universal: "https://beewallet.app/wc",
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map